import styles from './index.module.scss'
import Title from "../ui/title/Title";
import { useState } from "react";

type FiscalCheckType = {
  setEmailValue: (value: string) => void,
  setEmailValid?: (value: boolean) => void,
}

const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function FiscalCheck({ setEmailValue, setEmailValid }: FiscalCheckType) {
  const [emailErrorState, setEmailErrorState] = useState('');

  const onInputEmailChanged = (e: any) => {
    const emailValue = e.target.value.trim();
    const isValid = emailValue === '' || EMAIL_REGEXP.test(emailValue);
    setEmailValue(emailValue);
    setEmailValid?.(isValid);
    setEmailErrorState(!isValid ? 'Введите корректный e-mail' : '');
  };

  return (
    <div className={styles.wr}>
      <Title text="Для получения фискального чека введите адрес электронной почты" sx />
      <div className={styles.input}>
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.25 6.97519e-09H16.75C17.5801 -5.43467e-05 18.3788 0.317554 18.9822 0.887671C19.5856 1.45779 19.948 2.23719 19.995 3.066L20 3.25V12.75C20.0001 13.5801 19.6824 14.3788 19.1123 14.9822C18.5422 15.5856 17.7628 15.948 16.934 15.995L16.75 16H3.25C2.41986 16.0001 1.62117 15.6824 1.01777 15.1123C0.414367 14.5422 0.0519987 13.7628 0.00500012 12.934L6.97518e-09 12.75V3.25C-5.43467e-05 2.41986 0.317554 1.62117 0.887672 1.01777C1.45779 0.414367 2.23719 0.0519987 3.066 0.00500012L3.25 6.97519e-09H16.75H3.25ZM18.5 5.373L10.35 9.663C10.258 9.71161 10.1568 9.74054 10.053 9.74795C9.94921 9.75535 9.84499 9.74106 9.747 9.706L9.651 9.664L1.5 5.374V12.75C1.50002 13.1892 1.66517 13.6123 1.96268 13.9354C2.26019 14.2585 2.6683 14.4579 3.106 14.494L3.25 14.5H16.75C17.1893 14.5 17.6126 14.3347 17.9357 14.037C18.2588 13.7392 18.4581 13.3309 18.494 12.893L18.5 12.75V5.373ZM16.75 1.5H3.25C2.81081 1.50002 2.38768 1.66517 2.06461 1.96268C1.74154 2.26019 1.54214 2.6683 1.506 3.106L1.5 3.25V3.679L10 8.152L18.5 3.678V3.25C18.5 2.81065 18.3347 2.38739 18.037 2.06429C17.7392 1.74119 17.3309 1.5419 16.893 1.506L16.75 1.5Z"
            fill="#FF8C4B" />
        </svg>

        <input type="email" placeholder="Введите ваш e-mail" onChange={onInputEmailChanged} />
      </div>
      {emailErrorState ? <div className={styles.error}>{emailErrorState}</div> : null}
    </div>
  );
}
